import ContentOverlay from "../components/content_overlay";

function IntroPage() {
  return (
    <ContentOverlay
      heading={<h2 style={{ textAlign: "center" }}>Issue Introduction</h2>}
      text_content={ <p style={{fontSize:"0.999999em"}}>The WG is one among 36 global biodiversity hotspots
      (https://www.conservation.org/) and 8 hottest hotspots of biodiversity
      (https://www.iucn.org/) with exceptional endemic flora and fauna. The
      region is endowed with 4,600 species of flowering plants (38% endemics),
      330 butterflies (11% endemics), 156 reptiles (62% endemics), 508 birds (4%
      endemics), 120 mammals (12% endemics), 289 fishes (41% endemics) and 135
      amphibians (75% endemics). It covers an area of approximately 160,000 sq.
      km and extends from 8° N to 21° N latitudes and 73° E to 77° E longitudes.
      It is considered as a water tower of India due to numerous streams
      originates and draining millions of hectares. The rivers of WG sustains
      water ensuring water and food security of 245+ million people in the
      peninsular Indian states. WG has 261 persons per square kilometer located
      in six states under such as Kerala, Tamil Nadu, Karnataka, Goa,
      Maharashtra, Gujrat and Dadra and Nagar Haveli (Union Territory). The
      region has tropical evergreen forests, moist deciduous forests, scrub
      jungles, sholas, savannas including the high rainfall savannas of which
      10% of the forest area is under protection legally. The region has 261
      persons per square kilometer density of population. Areca nut, coconut,
      coffee, tea, rubber, spices, paddy, sugarcane, cereals, cotton are major
      agriculture and horticulture products grown across the regions. <br />
      <br /> Plant diversity is the variety of plant species in an area, which
      occurs mainly due to the different characteristics and adaptations shown
      by plants to different environments. The current issue of Sahyadri E- news
      (Issue XCI) documents plant diversity in Kerala, including major habits
      like trees, shrubs and herbs and the district wise spatial analysis of
      species. Family-wise species distribution in all districts is analysed
      through open-source GIS, which highlights species richness in districts
      and provides insights to the species composition in the state. Compilation
      of the information reveal that there are 1860 plant species in which 480
      species are trees, 366 shrubs, and 1014 herbs of Kerala. Herbs dominate in
      all districts with the highest species composition in Idukki district."
      </p>
      }
      />
  );
 
}

export default IntroPage;
